import { MailSubscriptionReducer } from '@/entities/mailSubscription';

import { LoadingReducer } from '@/shared/services/loading';

import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
  mailSubscription: MailSubscriptionReducer,
  loading: LoadingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production' && {
    name: 'MailSubscription Redux FSD',
  },
});

export default store;

export type MailSubscriptionRootState = ReturnType<typeof store.getState>;
export type MailSubscriptionAppDispatch = typeof store.dispatch;
export type MailSubscriptionAppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  MailSubscriptionRootState,
  unknown,
  Action<string>
>;
